/** 用户消息API */
import type { Api } from '@/typings/api';
import { get, post } from '../../request';
const prefix = '/notify/notificationAccount';
/**
 * 分页查询用户消息
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Notify.NotificationAccount> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询用户消息列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Notify.NotificationAccount> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个用户消息
 *
 * @param id 用户消息ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Notify.NotificationAccount> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存用户消息
 *
 * @param params 用户消息信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新用户消息信息
 *
 * @param params 用户消息信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除用户消息
 *
 * @param id 用户消息ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除用户消息
 *
 * @param ids 用户消息ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 消息已读
 *
 * @param id 用户消息ID
 */
export const readNotification = (id: string) => {
  return get(`${prefix}/read`, { id });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  readNotification
};
